/* src/firebase.js */
import { initializeApp } from "firebase/app";
import { initializeAuth, browserLocalPersistence, indexedDBLocalPersistence, browserPopupRedirectResolver } from "firebase/auth";
import { initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAlLgBbYXi1yO_Rl4cBK4TCux3UF4csHGQ",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sistema-bks.firebaseapp.com",
  projectId: "sistema-bks",
  storageBucket: "sistema-bks.firebasestorage.app",
  messagingSenderId: "734042103109",
  appId: "1:734042103109:web:9e9463101e6409d5a2f22c",
};

export const app = initializeApp(firebaseConfig);
// `popupRedirectResolver` es OBLIGATORIO para `signInWithPopup` cuando la instancia se crea con
// `initializeAuth` (a diferencia de `getAuth`, que lo trae de serie). Sin él, el SDK lanza
// `auth/argument-error` antes de abrir la ventana (`_withDefaultResolver` en @firebase/auth).
// Faltó desde el 13-abr-2026 hasta el 6-oct-2026: ningún usuario pudo entrar con Google
// (medido en Auth: 70 de 70 sin proveedor). Lo fija `__tests__/accesoConGoogle.jest.test.js`.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});

// 🔧 Auto-detecta long-polling y habilita caché persistente (arregla QUIC / proxies)
export const db = initializeFirestore(app, {
  // Auto-detecta si QUIC falla consistentemente → fallback a long polling
  experimentalAutoDetectLongPolling: true,

  // Deshabilita fetch streams (mejor compatibilidad con proxies)
  useFetchStreams: false,

  // Caché persistente local para resiliencia durante desconexiones
  localCache: persistentLocalCache()
});

export const functions = getFunctions(app, 'us-central1'); // ✅ callable puro con región
export const storage = getStorage(app);